module.exports = __webpack_public_path__ + "h5/img/test02.fe93eb73.jpg";